module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "registrosModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "registrosModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "registros"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionario),
      expression: "funcionario"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.funcionario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.trocaUsuario(_vm.funcionario)
      }]
    }
  }, _vm._l((_vm.autenticados), function(autenticado) {
    return _c('option', {
      key: autenticado.id,
      domProps: {
        "value": autenticado
      }
    }, [_vm._v("\n                    " + _vm._s('Registro ' + autenticado.registroFormatado) + "\n                  ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Esse Registro",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "registrosModalLabel"
    }
  }, [_vm._v("\n            Escolha seu registro\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-field"
  }, [_c('p', [_vm._v("\n                Você possui mais de um registro. Sempre que quiser, você pode\n                trocar de usuário no menu à direita, em \"Trocar Registro\".\n              ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Qual registro deseja usar agora?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-user-circle-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f664b0e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/registros-modal.vue
// module id = KDVI
// module chunks = 5